import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['slide', 'indicator']
  static values = {
    autoRotate: { type: Boolean, default: true },
    interval: { type: Number, default: 10000 },
    currentIndex: { type: Number, default: 0 },
  }

  connect() {
    this.slideTargets.forEach((slide, index) => {
      slide.style.opacity = index === this.currentIndexValue ? '1' : '0'
      slide.style.transition = 'opacity 0.5s ease-in-out'
      slide.style.pointerEvents = index === this.currentIndexValue ? 'auto' : 'none'
    })
    this.updateIndicators()

    if (this.autoRotateValue && this.slideTargets.length > 1) {
      this.startAutoRotation()
    }
  }

  disconnect() {
    this.stopAutoRotation()
  }

  next() {
    this.stopAutoRotation()
    this.currentIndexValue = (this.currentIndexValue + 1) % this.slideTargets.length
    this.showSlide(this.currentIndexValue)
    this.restartAutoRotation()
  }

  previous() {
    this.stopAutoRotation()
    this.currentIndexValue =
      this.currentIndexValue === 0 ? this.slideTargets.length - 1 : this.currentIndexValue - 1
    this.showSlide(this.currentIndexValue)
    this.restartAutoRotation()
  }

  goToSlide(event) {
    this.stopAutoRotation()
    const index = parseInt(event.currentTarget.dataset.index)
    this.currentIndexValue = index
    this.showSlide(index)
    this.restartAutoRotation()
  }

  showSlide(index) {
    this.slideTargets.forEach((slide, i) => {
      slide.style.opacity = i === index ? '1' : '0'
      slide.style.pointerEvents = i === index ? 'auto' : 'none'
    })
    this.updateIndicators()
  }

  updateIndicators() {
    this.indicatorTargets.forEach((indicator, index) => {
      if (index === this.currentIndexValue) {
        indicator.classList.add('btn-active')
      } else {
        indicator.classList.remove('btn-active')
      }
    })
  }

  startAutoRotation() {
    if (this.autoRotateValue && this.slideTargets.length > 1) {
      const interval = this.intervalValue || 10000
      this.autoRotationTimer = setInterval(() => {
        this.currentIndexValue = (this.currentIndexValue + 1) % this.slideTargets.length
        this.showSlide(this.currentIndexValue)
      }, interval)
    }
  }

  stopAutoRotation() {
    if (this.autoRotationTimer) {
      clearInterval(this.autoRotationTimer)
      this.autoRotationTimer = null
    }
  }

  restartAutoRotation() {
    if (this.autoRotateValue) {
      const interval = this.intervalValue || 10000
      setTimeout(() => this.startAutoRotation(), interval)
    }
  }
}
